import { render, staticRenderFns } from "./flow_editor.vue?vue&type=template&id=22030980&"
import script from "./flow_editor.vue?vue&type=script&lang=js&"
export * from "./flow_editor.vue?vue&type=script&lang=js&"
import style0 from "./flow_editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports